import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { Loader } from "@egovernments/digit-ui-react-components";

const DscSanction = ({ formData, handleTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, setValue, watch, reset } = useForm({});
  let drawingDetail = formData?.drawingDetail || [];

  const tenantId = formData?.tenantId || Digit.ULBService.getStateId() || "up";
  const docDxf = formData?.documents?.find((d) => d.documentType === "dxfDrawing")?.fileStoreId ||
    formData?.additionalDetails?.documents?.find((d) => d.documentType === "dxfDrawing")?.fileStoreId;
  const docPdf = formData?.documents?.find((d) => d.documentType === "drawingPdf")?.fileStoreId ||
    formData?.additionalDetails?.documents?.find((d) => d.documentType === "drawingPdf")?.fileStoreId;

  const docDxfUrl = docDxf ? `/filestore/v1/files/id?fileStoreId=${docDxf}&tenantId=${tenantId}` : null;
  const docPdfUrl = docPdf ? `/filestore/v1/files/id?fileStoreId=${docPdf}&tenantId=${tenantId}` : null;

  if (drawingDetail.length === 0) {
    // Construct a fallback row if the drawing details array is empty but root level file properties exist
    if (
      formData?.selfDrawingPdfUrl ||
      formData?.editPdfViaPdfUrl ||
      docPdfUrl ||
      formData?.updatedDxfFile ||
      formData?.proposalUrl ||
      formData?.planReport ||
      formData?.dxfFile ||
      docDxfUrl ||
      formData?.sanctionDrawingUrl ||
      (typeof formData?.IsSignedDrawingPdfURL === "string" && formData?.IsSignedDrawingPdfURL)
    ) {
      drawingDetail = [{
        drawingPdf: formData?.selfDrawingPdfUrl || formData?.editPdfViaPdfUrl || docPdfUrl || formData?.updatedDxfFile,
        planReport: formData?.planReport,
        dxfFile: formData?.dxfFile || docDxfUrl || formData?.updatedDxfFile,
        status: formData?.status,
        submittedOn: formData?.auditDetails?.lastModifiedTime || formData?.auditDetails?.createdTime,
        sanctionDrawingUrl: formData?.sanctionDrawingUrl || formData?.signedPdfUrl || (typeof formData?.IsSignedDrawingPdfURL === "string" ? formData?.IsSignedDrawingPdfURL : "")
      }];
    }
  }
  const [open, setOpen] = useState(false);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: "",
  });
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const onSubmit = (data) => {
    OpenPDFFromB64InPdfViewer();
  };

  // Define the columns you want to display
  const columns = [
    { id: "submissionIndex", label: "Submission", accessor: "" }, // New column for submission index
    { id: "drawingPdf", label: "Drawing PDF", accessor: "drawingPdf" },
    { id: "planReport", label: "Plan Report", accessor: "planReport" },
    { id: "dxfFile", label: ".dxf File", accessor: "dxfFile" },
    { id: "status", label: "Status", accessor: "status" },
    { id: "submittedOn", label: "Submitted On", accessor: "submittedOn" },
    { id: "sanctionDrawingUrl", label: "Digital Sign", accessor: "sanctionDrawingUrl" },
  ];
  const handleClose = () => {
    setOpen(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      // When EDCR flow is selected for map submission (employee), use "SD" as pdfType
      // For all other flows (e.g., PDF-based), keep "DIA"
      const isEdcrFlow = formData?.scrutinyFlow === "EDCR";
      const SignRequest = {
        applicationNo: formData?.applicationNo,
        pdfType: isEdcrFlow ? "SD" : "DIA",
      };
      const getSign = await Digit.DscService.getSignParams({ SignRequest });
      setSigningParams((prev) => ({
        ...prev,
        AuthToken: getSign?.SigningParameters?.authToken,
        SrcPdfB64: getSign?.SigningParameters?.pdfBase64,
        SignSettingName: getSign?.SigningParameters?.signSettingName,
        ReturnUrl: getSign?.SigningParameters?.returnURL,
        UserDataJson: getSign?.SigningParameters?.UserDataJson,
      }));
      setOpen(true);
      setLoading(false);
      console.log({ getSign, signingParams, AuthToken, SrcPdfB64, SignSettingName, ReturnUrl }, "getSingngn");
    } catch (error) {
      console.error(error, "error");
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const { AuthToken, SrcPdfB64 } = signingParams;

    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    // Set the form action
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");

    // Submit the form
    formRef.current.submit();
  };
  if (loading) {
    return <Loader />;
  }
  console.log({ signingParams }, "signinngParams");

  return (
    <section className="groupContainer" style={{ width: "78vw!important" }}>
      <form>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Drawing")}</h2>
          </div>
        </div>

        <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="drawing details table">
            <TableHead sx={{ backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C", color: "#fff" }}>
              <TableRow sx={{ height: "20px" }}>
                {columns.map((column) => (
                  <TableCell key={column.id} sx={{ color: "#fff" }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {drawingDetail.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => {
                    // Handle submission index separately
                    if (column.id === "submissionIndex") {
                      return <TableCell key={column.id}>Submission {index + 1}</TableCell>;
                    }

                    const value = row[column.accessor];

                    if (column.accessor === "submittedOn") {
                      return <TableCell key={column.id}>{value ? new Date(value).toLocaleString() : "N/A"}</TableCell>;
                    }

                    if (column.accessor === "drawingPdf") {
                      const isSigned = formData?.IsSignedDrawingPdfDscEmp === true;
                      let pdfUrl = value; // default to row's drawingPdf

                      if (isSigned) {
                        // Priority: selfDrawingPdfUrl → signedDrawingPdfURL → row.drawingPdf (value)
                        pdfUrl = formData?.selfDrawingPdfUrl || formData?.signedDrawingPdfURL || value;
                      }

                      return (
                        <TableCell key={column.id}>
                          {pdfUrl ? (
                            <FaFilePdf
                              color="#a10505"
                              style={{ width: "20px", height: "20px", cursor: "pointer" }}
                              onClick={() => window.open(pdfUrl, "_blank")}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }

                    if (column.accessor === "dxfFile") {
                      return (
                        <TableCell key={column.id}>
                          {value ? (
                            <img
                              src={"https://i.imgur.com/GDoAGny.png"}
                              style={{ width: "20px", height: "30px", cursor: "pointer" }}
                              onClick={() => window.open(value, "_blank")}
                              alt="DXF File"
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                    if (column.accessor === "sanctionDrawingUrl") {
                      // EDCR case: check last index of drawingDetail for signed file
                      const lastDetail = drawingDetail?.[drawingDetail.length - 1];
                      const signedPdfUrl = lastDetail?.signedPdfUrl;
                      const signedPdfId = lastDetail?.signedPdfId;
                      // Build URL from signedPdfId if direct URL is not available
                      const signedFileUrl = signedPdfUrl || (signedPdfId ? `/filestore/v1/files/id?fileStoreId=${signedPdfId}&tenantId=${tenantId}` : null);
                      // Hide button when IsSanctionDrawing is true (employee EDCR case)
                      const isSigned = formData?.IsSanctionDrawing === true;

                      return (
                        <TableCell key={column.id}>
                          {isSigned && signedFileUrl ? (
                            <FaFilePdf
                              color="#24b155"
                              style={{ width: "20px", height: "20px", cursor: "pointer" }}
                              onClick={() => window.open(signedFileUrl, "_blank")}
                              title="View Signed PDF"
                            />
                          ) : isSigned ? (
                            <span style={{ color: "#2e7d32", fontWeight: 500 }}>
                              ✓ File is signed
                            </span>
                          ) : (
                            <button
                              style={{
                                backgroundColor: "#157CB3",
                                color: "#fff",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              type="button"
                              onClick={handleSign}
                            >
                              Attach Digital Sign
                            </button>
                          )}
                        </TableCell>
                      );
                    }

                    return <TableCell key={column.id}>{value || "N/A"}</TableCell>;
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: open ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              background: "#fff",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            }}
          >
            <p style={{ margin: "15px" }}>By clicking on the Submit button, you will be redirected to the Third-Party Page.</p>
            <form
              id="PDFViewerDemo"
              method="POST"
              //target="_blank"
              ref={(el) => (formRef.current = el)}
              onSubmit={handleSubmit(onSubmit)}
              action="https://digital.abmapplication.com/Console/PdfViewerSigning"
            >
              <input type="hidden" id="AuthToken" name="AuthToken" value={signingParams.AuthToken} />
              <input type="hidden" id="SignSettingName" name="SignSettingName" value={signingParams.SignSettingName} />
              <input type="hidden" id="SrcPdfB64" name="SrcPdfB64" value={signingParams.SrcPdfB64} />
              <input type="hidden" id="SrcPdfPath" name="SrcPdfPath" value="" />
              <input type="hidden" id="SignedPdfPath" name="SignedPdfPath" value="" />
              <input type="hidden" id="UserDataJson" name="UserDataJson" value={signingParams.UserDataJson} />
              <input
                type="hidden"
                id="ReturnUrl"
                name="ReturnUrl"
                value={signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"}
              />

              <div class="button-inline">
                <div style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    onClick={handleClose}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Cancel
                  </button>
                  <button
                    value="Submit"
                    type="submit"
                    onClick={OpenPDFFromB64InPdfViewer}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </form>
    </section>
  );
};

export default DscSanction;
